import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage =
    'Hola, me interesa la propuesta Papaupa × TNO Network (Plan Multi-Pantalla $300/mes: rotativa/micros 24/7, menciones en Punto de Fe, Somos Padres y 2do Escalón, inserts, banners y redes).';

  return (
    <Box sx={{ pb: 4 }}>
      <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
        ¿Arrancamos con este esquema?
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 640, mx: 'auto', lineHeight: 1.7 }}
      >
        El presupuesto está distribuido para que Papaupa «bañe» toda la señal de video y audio durante el mes:
        pantalla, radio, menciones y redes en un solo plan.
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          gap={2}
        >
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={() => {
              const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
              window.open(url, '_blank');
            }}
          >
            Contactar por WhatsApp
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Papaupa × TNO Network | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
